

var stores = [
 {
   "StoreName":    "Arnold",
   "Address_1":    "160-166 Front Street",
   "City":         "Arnold",
   "Postcode":     "NG5 7EG",
   "Lat":          53.0051285,
   "Lng":          -1.1268027,
   "Phone":        "0115 9261444",
 },
 
 {
   "StoreName":    "Benwell",
   "Address_1":    "Unit 2, Adelaide Centre",
   "Address_2":    "Adelaide Terrace",
   "City":         "Newcastle-under-Tyne",
   "Postcode":     "NE4 8BE",
   "Lat":          54.97024949999999,
   "Lng":          -1.6557518,
   "Phone":        "0191 272 0957",
 },
   {
   "StoreName":    "Burton-on-Trent",
   "Address_1":    "195A Station Street",
   "City":         "Burton-on-Trent",
   "Postcode":     "DE14 1BH",
   "Lat":          52.8034793,
   "Lng":          -1.6315617,
   "Phone":        "01283 512 423",
 },  
 
 {
   "StoreName":    "Chesterfield",
   "Address_1":    "1-5 Burlington Street",
   "City":         "Chesterfield",
   "Postcode":     "S40 1RS",
   "Lat":          53.2357052,
   "Lng":          -1.4264942,
   "Phone":        "01246 202 668",
 },
 {
   "StoreName":    "Hexham",
   "Address_1":    "39a Fore Street",
   "City":         "Hexham",
   "Postcode":     "NE46 1LZ",
   "Lat":          54.9705321,
   "Lng":          -2.1009735,
   "Phone":        "01434 609 822",
 },
{
   "StoreName":    "Loughborough",
   "Address_1":    "31-33 Cattle Market",
   "City":         "Loughborough",
   "Postcode":     "LE11 3DL",
   "Lat":          52.7706470,
   "Lng":          -1.2067091,
   "Phone":        "01509 269 057",
 },
{
   "StoreName":    "Manna Farm",
   "Address_1":    "Old Rufford Road",
   "City":         "Calverton",
   "Postcode":     "NG14 6NW",
   "Lat":          53.0574135,
   "Lng":          -1.1113627,
   "Phone":        "0115 9655686",
 }, 
 {
   "StoreName":    "Newcastle-Under-Lyme",
   "Address_1":    "114 High Street",
   "City":         "Newcastle-under-Lyme",
   "Postcode":     "ST5 1PT",
   "Lat":          53.0096285,
   "Lng":          -2.2256493,
   "Phone":        "01782 620498",
 },
 {
   "StoreName":    "Northwich",
   "Address_1":    "38 Witton Street",
   "City":         "Northwich",
   "Postcode":     "CW9 5AG",
   "Lat":          53.26186509999999,
   "Lng":          -2.5113285,
   "Phone":        "01606 43324",
 },
 {
   "StoreName":    "Sale",
   "Address_1":    "4 Hereford Street",
   "City":         "Sale",
   "Postcode":     "M33 7XN",
   "Lat":          53.424608,
   "Lng":          -2.3231266,
   "Phone":        "0161 973 1407",
 },
 {
   "StoreName":    "Shirley",
   "Address_1":    "245 Stratford Road",
   "City":         "Shirley",
   "Postcode":     "B90 3AL",
   "Lat":          52.41118179999999,
   "Lng":          -1.8262008,
   "Phone":        "0121 744 9179",
 },
 {
   "StoreName":    "Watford",
   "Address_1":    "259-265 St Albans Road",
   "City":         "Watford",
   "Postcode":     "WD24 5BN",
   "Lat":          51.6716547,
   "Lng":          -0.3965674,
   "Phone":        "01923 803149",
 }
];


function RestoredShopsDataFeed() {

 jQuery.extend(this, new storeLocator.StaticDataFeed);

 var storeList = [];

 for (var i = 0; i < stores.length; i++) {
   var storeData = stores[i];

   var position = new google.maps.LatLng(storeData.Lat, storeData.Lng);
   var fmtAddress = this.join_([storeData.Address_1, storeData.Address_2, storeData.Address_3, 
                                storeData.City, storeData.County, storeData.Postcode], ',<br>');
   var store = new storeLocator.Store(i, position, null, {
     title: storeData.StoreName,
     address: fmtAddress,
     phone: storeData.Phone,
   });

   // override default info in Panel
   /*
   store.getInfoPanelContent = function() {
     var details = this.getDetails();
     return '<h3 class="title">' + details.title + '</h3>' + '<p class="address">' + 
            details.address + '</p>' + '<a class="tel" href="tel:' + details.tel + '">' + 
            details.tel + '</a>' + '<p class="hours">' + details.hours + '</p>';
   };
   */

   // override default info in Map
   /*
   store.getInfoWindowContent = function() {
     var details = this.getDetails();
     return '<h3 class="title">' + details.title + '</h3>' + '<p class="address">' + 
            details.address + '</p>' + '<a class="tel" href="tel:' + details.tel + '">' + 
            details.tel + '</a>' + '<p class="hours">' + details.hours + '</p>';
   };
   */

   storeList.push(store);
 }

 this.setStores(storeList);
}


RestoredShopsDataFeed.prototype.join_ = function(arr, sep) {
  var parts = [];
  for (var i = 0, ii = arr.length; i < ii; i++) {
    arr[i] && parts.push(arr[i]);
  }
  return parts.join(sep);
};